// Cartoon F1-style race car, fully inline SVG (resolution-independent).
// Used large on the title screen and small as a racer token on the track.

interface Props {
  /** Body / nose / cabin fill. */
  color?: string;
  /** Number shown on the roundel. */
  number?: string | number;
  /** Rendered width in px (height scales to match the 560×270 viewBox). */
  width?: number;
  /** Spin the wheels (racing) — off by default for static badges. */
  spinning?: boolean;
  /** Float + rock gently (hero car). */
  bobbing?: boolean;
  /** Helmet dome accent colour (default red). */
  helmetColor?: string;
  className?: string;
  ariaLabel?: string;
}

export default function RaceCar({
  color = "#ff5a4d",
  number = "1",
  width = 540,
  spinning = false,
  bobbing = false,
  helmetColor = "#ff5a4d",
  className = "",
  ariaLabel = "Race car",
}: Props) {
  const wheel = spinning ? "animate-wheel" : "";
  return (
    <div className={`${bobbing ? "animate-car-bob" : ""} ${className}`} style={{ transformOrigin: "center bottom" }}>
      <svg
        viewBox="0 0 560 270"
        width={width}
        height={(width * 270) / 560}
        style={{ overflow: "visible", maxWidth: "100%", height: "auto", filter: "drop-shadow(0 16px 12px rgba(0,0,0,.28))" }}
        role="img"
        aria-label={ariaLabel}
      >
        {/* rear spoiler */}
        <rect x="34" y="92" width="86" height="20" rx="8" fill="#1c2a63" />
        <rect x="58" y="100" width="16" height="60" rx="6" fill="#1c2a63" />
        {/* body */}
        <rect x="70" y="150" width="420" height="64" rx="30" fill={color} />
        {/* nose */}
        <polygon points="470,150 540,178 470,214" fill={color} />
        {/* lower skirt */}
        <rect x="150" y="206" width="240" height="20" rx="8" fill="#1c2a63" opacity=".5" />
        {/* cabin */}
        <rect x="170" y="108" width="190" height="70" rx="26" fill={color} />
        {/* side accent stripe */}
        <rect x="92" y="178" width="380" height="14" rx="7" fill="#ffffff" opacity=".85" />
        {/* windshield glass */}
        <polygon points="330,114 372,168 300,168 300,114" fill="#2a3b6b" />
        <polygon points="334,120 360,162 318,162 318,120" fill="#5b78c4" />
        {/* driver helmet */}
        <circle cx="235" cy="120" r="34" fill="#ffffff" />
        <path d="M205 122 a30 30 0 0 1 60 0 z" fill={helmetColor} />
        <rect x="226" y="112" width="40" height="18" rx="9" fill="#2a3b6b" />
        {/* number roundel */}
        <circle cx="255" cy="184" r="30" fill="#ffffff" stroke="#1c2a63" strokeWidth="5" />
        <text
          x="255"
          y="198"
          fontFamily="'Luckiest Guy', cursive"
          fontSize="40"
          fill="#ff5a4d"
          textAnchor="middle"
        >
          {number}
        </text>
        {/* headlight */}
        <circle cx="500" cy="190" r="11" fill="#fff2a8" stroke="#1c2a63" strokeWidth="4" />
        {/* wheels */}
        <g className={wheel} style={{ transformBox: "fill-box", transformOrigin: "center" }}>
          <circle cx="150" cy="214" r="50" fill="#23262e" />
          <circle cx="150" cy="214" r="26" fill="#e9edf5" />
          <rect x="146" y="170" width="8" height="88" fill="#c2c9d6" />
          <rect x="106" y="210" width="88" height="8" fill="#c2c9d6" />
          <circle cx="150" cy="214" r="8" fill="#1c2a63" />
        </g>
        <g className={wheel} style={{ transformBox: "fill-box", transformOrigin: "center" }}>
          <circle cx="410" cy="214" r="50" fill="#23262e" />
          <circle cx="410" cy="214" r="26" fill="#e9edf5" />
          <rect x="406" y="170" width="8" height="88" fill="#c2c9d6" />
          <rect x="366" y="210" width="88" height="8" fill="#c2c9d6" />
          <circle cx="410" cy="214" r="8" fill="#1c2a63" />
        </g>
      </svg>
    </div>
  );
}
